import {
    CUSTOMER_LIST,
    CUSTOMER_PAGINATION,
    CUSTOMER_COMPANY_LIST,
} from "./constant";

export const initialState = {
    customersList: [],
    customersPagination: {},
    customerCompanyList: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case CUSTOMER_LIST:
            return {
                ...state,
                customersList: action.payload || [],
            };

        case CUSTOMER_PAGINATION:
            return {
                ...state,
                customersPagination: action.payload || {},
            };

        case CUSTOMER_COMPANY_LIST:
            return {
                ...state,
                customerCompanyList: action.payload || [],
            };

        default:
            return state;
    }
};